// extracted by mini-css-extract-plugin
export default {"Restaurante":"Restaurante_Restaurante__ZFpgF","VerMais":"Restaurante_VerMais__pNZkZ","Titulo":"Restaurante_Titulo__Su-b4"};